import React , {Component} from 'react';

import {Link} from "react-router-dom";
import backIcon from './../assets/images/icons/back-2.svg';
import * as vars from "./Vars";
import * as axios from "axios/index";
import Loader from './loader/AddressLoader';
import AddressSingle from './section/AddressSingleMapIr';
import NewAddress from "./section/NewAddressV3MapIr";

class AddressesV3 extends Component{

    constructor(props){

        super(props)
        this.state = {
            newAddress : false ,
            requestLoading : true ,
            addresses : [] ,
        }
    }
    getNewAddress(address)
    {
        this.setState({
            addresses : [ address , ...this.state.addresses]
        })
    }

    onRemoveHandler(addressId){
        const addresses = []
        this.state.addresses.map((address , index) => {
            if (addressId !== address.id)
            {
                addresses.push(address)
            }
        })
        this.setState({
            addresses : addresses
        })
    }

    onUpdateHandler(updatedAddress){
        const addresses = []
        this.state.addresses.map((address , index) => {
            if (updatedAddress.id !== address.id)
            {
                addresses.push(address)
            }
            else
            {
                addresses.push(updatedAddress)
            }
        })
        this.setState({
            addresses : addresses
        })
    }

    newAddressHandler(){
        this.setState({
            newAddress: !this.state.newAddress
        })
    }


    componentDidMount(){
        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        axios.post(vars.Url +'api/v1/address' , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                // console.log(data)
                this.setState({
                    requestLoading : false ,
                    addresses : data.addresses ,
                })
            })
            .catch( (error) => {
                let data = error.response.data.data
            })
    }

    render(){
        return(

            <div id="main-custom-1" className="text-decoration-none">
                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/profile">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>
                                            <span className="title">
                                                آدرس های من
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>


                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1">

                                {
                                    this.state.addresses.map((address , index) =>

                                        <AddressSingle address={address} thisId={index} key={index} onUpdateHandler={this.onUpdateHandler.bind(this)} onRemoveHandler={this.onRemoveHandler.bind(this)} />

                                    )
                                }


                                {
                                    this.state.requestLoading === true ? (<Loader />) : (``)
                                }


                                <div className="row no-gutters justify-content-center mt-5">
                                    <div className="col-auto">
                                        <div className="btn btn-custom-3"  onClick={this.newAddressHandler.bind(this)}>
                                            <i className="fas fa-plus btn-item-icon pl-2" />
                                            آدرس جدید
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <NewAddress getNewAddress={this.getNewAddress.bind(this)} newAddress={this.state.newAddress} newAddressHandler={this.newAddressHandler.bind(this)}/>

            </div>
        )
    }
}

export default AddressesV3;